@if (data) {
	@let title = data.title;
	@let status = data.status;

	<div class="bp-modal mod-lg cool-off-notification-modal">
		@if (status === COOL_OFF_TRADE_STATUSES.COOLING_OFF || status === COOL_OFF_TRADE_STATUSES.BLOCKED) {
			<bp-modal-header [title]="title">
				<a
					right
					(click)="close()"
					(keydown.enter)="close()"
					[tabIndex]="0">
					<strong>{{ "close" | translate }}</strong>
				</a>
			</bp-modal-header>
		}
		<div class="bp-modal-body">
			@if (status === COOL_OFF_TRADE_STATUSES.PENDING_CHECK) {
				<div class="title">{{ title }}</div>
			}
			<div class="messages">
				@for (message of data.messages; track data.messages) {
					<p>{{ message }}</p>
				}
			</div>
			@if (status === COOL_OFF_TRADE_STATUSES.PENDING_CHECK) {
				<div class="action-buttons">
					@for (button of data.cta; track button.action) {
						@if (button.action === COOL_OFF_CTA_ACTION.CONFIRM) {
							<button
								class="btn btn-primary btn-wide"
								(click)="confirm()">
								{{ button.text }}
							</button>
						}

						@if (button.action === COOL_OFF_CTA_ACTION.CANCEL) {
							<a
								class="link"
								(click)="logout()">
								{{ button.text }}
							</a>
						}
					}
				</div>





			}
		</div>
	</div>
}